import React, { Fragment, useContext } from 'react';
import { store } from './Customer';
import { store as mainStore } from '../../../../../../store';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

const Alerts = () => {
  const {
    state: { customer },
    dispatch,
  } = useContext(store);
  const { showMessage, showError } = useContext(mainStore);
  return (
    <div style={{display: 'grid', gridTemplateColumns:'1fr',gridGap:'10px',margin:'15px 0'}}>
      {customer?.isDeleted && <Alert severity="error"><AlertTitle>اخطار</AlertTitle>این کاربر حذف شده است</Alert>}
      {customer?.status==='pending' && <Alert severity="warning"><AlertTitle>توجه</AlertTitle>این کاربر غیر فعال است</Alert>}
    </div>
  )
}

export default React.memo(Alerts)